module.exports = __webpack_public_path__ + "img/img7.7eb1ab77.png";